module.exports = __webpack_public_path__ + "img/plus.928027c9.svg";